
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./allExternalUserEmailerStyle.scss"
import { Button } from "reactstrap";
type AppProps = {
  data: any[] | [];
  tableHeader: TableHeadersType[];
  handleShowAllEmailerAssigned:(data:any)=>void;
};
const AllExternalUserEmailerTableData = ({ data, tableHeader ,handleShowAllEmailerAssigned}: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value == "name") {

                  return <td >
                    <div>
                   <span style={{fontSize:'14px', fontWeight:'500'}}> {itemData?.name}</span>
                    <div>
                   {itemData?.email_id?.length > 45 ? (
                        <>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-filter-invoice">
                                {itemData?.email_id}
                              </Tooltip>
                            }
                          >
                            <span style={{ color: "#6e7491", fontSize: "12px" }}>
                              {itemData?.email_id.toLowerCase()?.substr(0, 40) +
                                (itemData?.email_id && itemData?.email_id?.length > 40
                                  ? "..."
                                  : "")}
                            </span>
                          </OverlayTrigger>
                          <br></br>
                          <span style={{ color: "#6e7491", fontSize: "12px" }}>
                            {itemData?.mobile && itemData?.mobile}
                          </span>
                        </>
                      ) : (
                        <>
                         <span style={{ color: "#6e7491", fontSize: "12px" }}> {itemData?.email_id}</span> 
                          <br></br>
                          <span style={{ color: "#6e7491", fontSize: "12px" }}>
                            {itemData?.mobile && itemData?.mobile}
                          </span>
                        </>
                      )}
                      </div>
                      </div>
                    </td>;
                } else if (item?.value == "client_name") {
                    let finalName = itemData?.client_name
                    ? `${itemData.client_name}${itemData.client_code ? ` (${itemData.client_code})` : ""}`
                    : itemData?.client_code
                    ? `${itemData.client_code}`
                    : "";
                  
                  return (
                    <td >{finalName?finalName:"--/--"}</td>
                  );
                } 
               

                else if (item?.value == "emailer_settings") {
                    const emailerList = itemData?.emailer_settings || [];
                    const maxVisible = 4;
                    
                    return (
                      <td style={{minWidth:'310px'}}>
                        {emailerList.length > 0 ? (
                          <>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                            {emailerList.slice(0, maxVisible).map((emailSetting:any, index:any) => (
                              <span key={index} className="blueColorBatch" style={{marginRight:'8px'}}>
                                {emailSetting}
                                {index < emailerList.length - 1 && index < maxVisible - 1 ? " " : ""}
                              </span>
                            ))}
                            {emailerList.length > maxVisible && (
                              <span style={{ color:'#262a44', fontSize:'14px', fontWeight:'500' }}>
                                {" "}
                                +{emailerList.length - maxVisible} more
                              </span>
                            )}
                            </div>
                          </>
                        ) : (
                          <span>--/--</span> 
                        )}
                      </td>
                    );
                  }
                  else if (item?.value=="action"){
                    return(
                        <td>

<div>
                  {
                    <span
                      style={{ display: "flex", alignItems: "center" }}
                      className=" pointer"
                      onClick={()=>handleShowAllEmailerAssigned(itemData)}
                    >
                    
                      <div>
                        <Button
                          outline
                          color="danger"
                          className="ouline-button-hover"
               
                           
                        >
                        
                          View All Emailers
                        </Button>
                      </div>
                     
                    </span>
                  }
                </div>
                        </td>
                    )
                  }
                  
              })}
            </tr>
          );
        })}
    </>
  );
};

export default AllExternalUserEmailerTableData;

